<template>
    <div class="signin-wrapper">
        <h1>Get started with <strong>Walter</strong></h1>
        <h2>Sign up for free</h2>
        <div id="firebaseui-auth-container"></div>
    </div>
</template>

<script>
import firebasePlugin from '@/plugins/firebase';

export default {
    mounted() {
        firebasePlugin.initFirebaseUI(() => {
            this.$router.push({
                name: 'Dashboard',
            });
        });
    },
};
</script>

<style lang="scss" scope>
.signin-wrapper {
    padding: 20px;

    h1 {
        font-size: 2rem;
        margin: 20px;
        strong {
            font-weight: bold;
        }
    }

    h2 {
        margin: 20px;
        font-size: 1.2rem;
    }
}
</style>
